import Product from '@src/quince-site-common/src/domains/Product'
import ProductOptionValue, {
  ProductOption,
  ProductOptionDisplayType,
  ProductOptionName,
} from '@src/quince-site-common/src/domains/ProductOption'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import { getDisplayKey } from '@src/utils/i18n.utils'

// TODO - support pack options˚
export const getProductOptions = (
  product: Product,
  selectedOptions: ProductVariantOption[],
  isI18nPreviewEnabled: boolean,
): { productOptions: ProductOption[]; siblingOptionNames: Set<string> } => {
  const cascadingProductOptions = productHelper
    .getCascadingProductOptions(product, selectedOptions)
    .filter(po => !po.isHidden)
    .map(productOption => {
      let updatedProductOption: ProductOption = { ...productOption }
      // Force displayType to text for gift card
      if (getIsForcedTextOption(product.id)) {
        updatedProductOption = new ProductOption({
          ...productOption,
          values: productOption.values?.map(v => {
            return { ...v, displayType: ProductOptionDisplayType.TEXT }
          }),
        })
      }

      // update optionValues for engraving and customization options
      // TODO(STRFRNT-2867) - remove this after release
      let optionValues: ProductOptionValue[] = []
      // For customization option
      if (productOption.name === ProductOptionName.Customization && productOption.displayType === 'Input') {
        optionValues = [
          new ProductOptionValue({
            displayType: ProductOptionDisplayType.DEPRECATED_INPUT,
            value: '',
          }),
        ]
      }
      // For engraving option
      else if (productOption.name === ProductOptionName.Engraving && productOption.displayType === 'Text Box') {
        optionValues = [
          new ProductOptionValue({
            displayType: ProductOptionDisplayType.INPUT,
            value: '',
            maxCharacterLimit: productOption.maxCharacterLimit,
          }),
        ]
      } else {
        optionValues = productOption.values ?? []
      }

      updatedProductOption = { ...updatedProductOption, values: optionValues }

      return updatedProductOption
    })

  const siblingOptionNames = new Set<string>()
  const siblingProductOptions =
    product.addOnProductOptionGroups?.map(group => {
      const values = group.groupItems.map(groupItem => {
        return new ProductOptionValue({
          value: groupItem.mergeOptionValue,
          displayType: ProductOptionDisplayType.TEXT,
          displayName: getDisplayKey(groupItem, 'mergeOptionValueDisplayName', groupItem.mergeOptionValue, isI18nPreviewEnabled),
        })
      })

      siblingOptionNames.add(group.groupOptionName)

      return new ProductOption({
        name: group.groupOptionName,
        displayName: getDisplayKey(group, 'groupOptionDisplayName', group.groupOptionName, isI18nPreviewEnabled),
        displaySequence: group.optionDisplaySequence,
        values: values,
      })
    }) ?? []
  const combinedProductOptions = [...siblingProductOptions, ...cascadingProductOptions]
  combinedProductOptions.sort((a, b) => a.displaySequence - b.displaySequence)

  return { productOptions: combinedProductOptions, siblingOptionNames }
}

export const getIsForcedTextOption = (productId?: number) => {
  const SHOW_TEXT_OPTION_PRODUCT_IDS = new Set<number | undefined>([44])
  return SHOW_TEXT_OPTION_PRODUCT_IDS.has(productId)
}

export const getSelectedOptionsWithSiblings = (selectedOptions: ProductVariantOption[], product: Product | null, isI18nPreviewEnabled: boolean) => {
  const selectedSiblingOptionValues: ProductVariantOption[] = []
  product?.addOnProductOptionGroups?.forEach(group => {
    group.groupItems.forEach(groupItem => {
      if (groupItem.spid === product.spid) {
        selectedSiblingOptionValues.push(
          new ProductVariantOption({
            name: group.groupOptionName,
            value: groupItem.mergeOptionValue,
            displayName: getDisplayKey(groupItem, 'mergeOptionValueDisplayName', groupItem.mergeOptionValue, isI18nPreviewEnabled),
          }),
        )
      }
    })
  })
  return [...selectedOptions, ...selectedSiblingOptionValues]
}
